"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hljs = void 0;
var core_1 = __importDefault(require("highlight.js/lib/core"));
var cpp_1 = __importDefault(require("highlight.js/lib/languages/cpp"));
var xml_1 = __importDefault(require("highlight.js/lib/languages/xml"));
var awk_1 = __importDefault(require("highlight.js/lib/languages/awk"));
var bash_1 = __importDefault(require("highlight.js/lib/languages/bash"));
var c_1 = __importDefault(require("highlight.js/lib/languages/c"));
var clojure_1 = __importDefault(require("highlight.js/lib/languages/clojure"));
var crystal_1 = __importDefault(require("highlight.js/lib/languages/crystal"));
var csharp_1 = __importDefault(require("highlight.js/lib/languages/csharp"));
var csp_1 = __importDefault(require("highlight.js/lib/languages/csp"));
var css_1 = __importDefault(require("highlight.js/lib/languages/css"));
var markdown_1 = __importDefault(require("highlight.js/lib/languages/markdown"));
var dart_1 = __importDefault(require("highlight.js/lib/languages/dart"));
var diff_1 = __importDefault(require("highlight.js/lib/languages/diff"));
var dockerfile_1 = __importDefault(require("highlight.js/lib/languages/dockerfile"));
var elixir_1 = __importDefault(require("highlight.js/lib/languages/elixir"));
var elm_1 = __importDefault(require("highlight.js/lib/languages/elm"));
var ruby_1 = __importDefault(require("highlight.js/lib/languages/ruby"));
var erlang_1 = __importDefault(require("highlight.js/lib/languages/erlang"));
var fsharp_1 = __importDefault(require("highlight.js/lib/languages/fsharp"));
var go_1 = __importDefault(require("highlight.js/lib/languages/go"));
var gradle_1 = __importDefault(require("highlight.js/lib/languages/gradle"));
var groovy_1 = __importDefault(require("highlight.js/lib/languages/groovy"));
var handlebars_1 = __importDefault(require("highlight.js/lib/languages/handlebars"));
var haskell_1 = __importDefault(require("highlight.js/lib/languages/haskell"));
var ini_1 = __importDefault(require("highlight.js/lib/languages/ini"));
var java_1 = __importDefault(require("highlight.js/lib/languages/java"));
var javascript_1 = __importDefault(require("highlight.js/lib/languages/javascript"));
var json_1 = __importDefault(require("highlight.js/lib/languages/json"));
var kotlin_1 = __importDefault(require("highlight.js/lib/languages/kotlin"));
var less_1 = __importDefault(require("highlight.js/lib/languages/less"));
var lisp_1 = __importDefault(require("highlight.js/lib/languages/lisp"));
var lua_1 = __importDefault(require("highlight.js/lib/languages/lua"));
var makefile_1 = __importDefault(require("highlight.js/lib/languages/makefile"));
var perl_1 = __importDefault(require("highlight.js/lib/languages/perl"));
var nginx_1 = __importDefault(require("highlight.js/lib/languages/nginx"));
var objectivec_1 = __importDefault(require("highlight.js/lib/languages/objectivec"));
var pgsql_1 = __importDefault(require("highlight.js/lib/languages/pgsql"));
var php_1 = __importDefault(require("highlight.js/lib/languages/php"));
var plaintext_1 = __importDefault(require("highlight.js/lib/languages/plaintext"));
var powershell_1 = __importDefault(require("highlight.js/lib/languages/powershell"));
var properties_1 = __importDefault(require("highlight.js/lib/languages/properties"));
var protobuf_1 = __importDefault(require("highlight.js/lib/languages/protobuf"));
var python_1 = __importDefault(require("highlight.js/lib/languages/python"));
var rust_1 = __importDefault(require("highlight.js/lib/languages/rust"));
var scala_1 = __importDefault(require("highlight.js/lib/languages/scala"));
var scss_1 = __importDefault(require("highlight.js/lib/languages/scss"));
var shell_1 = __importDefault(require("highlight.js/lib/languages/shell"));
var sql_1 = __importDefault(require("highlight.js/lib/languages/sql"));
var swift_1 = __importDefault(require("highlight.js/lib/languages/swift"));
var yaml_1 = __importDefault(require("highlight.js/lib/languages/yaml"));
var typescript_1 = __importDefault(require("highlight.js/lib/languages/typescript"));
core_1.default.registerLanguage('cpp', cpp_1.default);
core_1.default.registerLanguage('xml', xml_1.default);
core_1.default.registerLanguage('awk', awk_1.default);
core_1.default.registerLanguage('bash', bash_1.default);
core_1.default.registerLanguage('c', c_1.default);
core_1.default.registerLanguage('clojure', clojure_1.default);
core_1.default.registerLanguage('crystal', crystal_1.default);
core_1.default.registerLanguage('csharp', csharp_1.default);
core_1.default.registerLanguage('csp', csp_1.default);
core_1.default.registerLanguage('css', css_1.default);
core_1.default.registerLanguage('markdown', markdown_1.default);
core_1.default.registerLanguage('dart', dart_1.default);
core_1.default.registerLanguage('diff', diff_1.default);
core_1.default.registerLanguage('dockerfile', dockerfile_1.default);
core_1.default.registerLanguage('elixir', elixir_1.default);
core_1.default.registerLanguage('elm', elm_1.default);
core_1.default.registerLanguage('ruby', ruby_1.default);
core_1.default.registerLanguage('erlang', erlang_1.default);
core_1.default.registerLanguage('fsharp', fsharp_1.default);
core_1.default.registerLanguage('go', go_1.default);
core_1.default.registerLanguage('gradle', gradle_1.default);
core_1.default.registerLanguage('groovy', groovy_1.default);
core_1.default.registerLanguage('handlebars', handlebars_1.default);
core_1.default.registerLanguage('haskell', haskell_1.default);
core_1.default.registerLanguage('ini', ini_1.default);
core_1.default.registerLanguage('java', java_1.default);
core_1.default.registerLanguage('javascript', javascript_1.default);
core_1.default.registerLanguage('json', json_1.default);
core_1.default.registerLanguage('kotlin', kotlin_1.default);
core_1.default.registerLanguage('less', less_1.default);
core_1.default.registerLanguage('lisp', lisp_1.default);
core_1.default.registerLanguage('lua', lua_1.default);
core_1.default.registerLanguage('makefile', makefile_1.default);
core_1.default.registerLanguage('perl', perl_1.default);
core_1.default.registerLanguage('nginx', nginx_1.default);
core_1.default.registerLanguage('objectivec', objectivec_1.default);
core_1.default.registerLanguage('pgsql', pgsql_1.default);
core_1.default.registerLanguage('php', php_1.default);
core_1.default.registerLanguage('plaintext', plaintext_1.default);
core_1.default.registerLanguage('powershell', powershell_1.default);
core_1.default.registerLanguage('properties', properties_1.default);
core_1.default.registerLanguage('protobuf', protobuf_1.default);
core_1.default.registerLanguage('python', python_1.default);
core_1.default.registerLanguage('rust', rust_1.default);
core_1.default.registerLanguage('scala', scala_1.default);
core_1.default.registerLanguage('scss', scss_1.default);
core_1.default.registerLanguage('shell', shell_1.default);
core_1.default.registerLanguage('sql', sql_1.default);
core_1.default.registerLanguage('swift', swift_1.default);
core_1.default.registerLanguage('yaml', yaml_1.default);
core_1.default.registerLanguage('typescript', typescript_1.default);
exports.hljs = core_1.default;
//# sourceMappingURL=highlight.js-slim.js.map